import React from "react";

import ChalanLogo from "../../../assests/icons/ChallanBkash";

import { makeStyles } from "../../shared/materials/helper";
import SignInForm from "../../shared/forms/SignInForm";

const useStyles = makeStyles((theme) => ({
  container: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(8, 10),
    borderRadius: theme.spacing(2),
    background: "rgba(226, 19, 110, 0.06)",
    width: "25%",
  },
  header: {
    marginBottom: 4,
    opacity: 0.9,
    marginTop: 0,
  },
}));

export default function SignIn({ signIn }) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.container}>
        <div className={classes.paper}>
          <div className={classes.header}>
            <ChalanLogo />
          </div>

          <SignInForm signIn={signIn} />
        </div>
      </div>
    </React.Fragment>
  );
}
